export default defineNuxtRouteMiddleware(async (to, from) => {
  const currentPath = to.path;

  if (currentPath === '/' || !currentPath.endsWith('/')) {
    await navigateTo(currentPath + '/');
  }
});
